import http from "../../plugins/axios";

export default {
  getUserList(data) {
    return http.get({
      url: `/la/admin/tenant/optionsConfig/list`,
      data
    });
  },
  updateOptionConfig(data) {
    return http.post({
      url: `/la/admin/tenant/optionsConfig/updateOptionConfig`,
      data
    })
  },

  optionConfigs(data) {
    return http.get({
      url: `/la/admin/tenant/optionsConfig/optionConfigs`,
      data
    })
  }
};
